import { styled, ToggleButton } from "@mui/material";

export const StyledToggleButton = styled(ToggleButton)({
  padding: "2px 4px",
  fontSize: 14,
  lineHeight: 1,
});
